import React from "react";

import { CognitiveLoadTimeline as CognitiveLoadTimelineComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

import { sanitizeAndAlignCharts } from "@/utils/sanitizeTimeline";

const timelineMockDateRange = {
    from: "2025-02-17T15:30:00",
    to: "2025-02-17T15:40:00",
};

const CognitiveLoadTimeline: React.FC = () => {
    const {
        cognitiveLoadTimelineData,
        isFetchingCognitiveLoadTimeline,
        isErrorCognitiveLoadTimeline,
    } = useSessionDetailsContext();

    if (isFetchingCognitiveLoadTimeline) {
        return <ContentLoader height="30rem" />;
    }

    if (isErrorCognitiveLoadTimeline && !isFetchingCognitiveLoadTimeline) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="19.6875rem"
                />
            </ComponentWrapper>
        );
    }

    const timelineCharts = cognitiveLoadTimelineData?.["combined-custom-charts"];
    const breakdownData = cognitiveLoadTimelineData?.["cognitive-load-breakdown"];

    const sanitizedData = sanitizeAndAlignCharts(timelineCharts);

    return (
        <CognitiveLoadTimelineComponent
            timelineData={{
                timelineData: sanitizedData as never,
                from: timelineMockDateRange.from,
                to: timelineMockDateRange.to,
            }}
            breakdownData={breakdownData}
        />
    );
};

export default CognitiveLoadTimeline;
